import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE,
} from '../types';

export const incompleteOrdersRequested = () => {
  return {
    type: INCOMPLETE_ORDERS_REQUESTED
  }
};

export const incompleteOrdersSuccess = (orders) => {
  return {
    type: INCOMPLETE_ORDERS_SUCCESS,
    payload: orders
  }
};

export const incompleteOrdersFailure = () => {
  return {
    type: INCOMPLETE_ORDERS_FAILURE
  }
};

export const getIncompleteOrders = (shopUrl, payload, direction, endCursor, startCursor) => {
  return (dispatch) => {
    dispatch(incompleteOrdersRequested());

    let endPoint = Config.baseUrl + Config.orders + Config.incomplete;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    let body = {
      'direction': direction,
      'endCursor': endCursor,
      'startCursor': startCursor
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(incompleteOrdersSuccess(response.data));
      })
  }
}
